import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Globe, Lock, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, packageBonuses, packageExtras, packageVolumes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white relative" data-id="element-174" data-mp="1jai9cuzlw1rm">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-175" data-mp="1nbbx9od1tgki">
        <div className="text-center mb-10" data-id="element-176" data-mp="1ncwrfcvgaxhu">
          <h2 className="text-3xl md:text-5xl font-black uppercase mb-3 text-zinc-950" data-id="element-177" data-mp="1s8u85kamm5v5">
            Your complete <span className="text-violet-600" data-id="element-178" data-mp="1x9rpjuntavvl">MMA Coach Ready</span> package
          </h2>
          <p className="font-display font-bold uppercase tracking-wide text-violet-900 text-sm md:text-base" data-id="element-179" data-mp="2282y822df0c8">
            The complete 6-in-1 coaching system — ready for your next session.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-violet-50 border-2 border-violet-600 rounded-3xl p-1 relative shadow-xl shadow-violet-900/10" data-id="element-180" data-mp="7ul7y7akzpdi">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-violet-950 text-white font-display font-extrabold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-181" data-mp="1coins4j94y6q">
            <Sparkles size={14} className="text-amber-400" aria-hidden="true" data-id="element-182" data-mp="20fxvydxpm9pw" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-183" data-mp="1vgl8bqz0kym9">
            <div className="text-left max-w-md mx-auto space-y-5 mb-8" data-id="element-184" data-mp="1rg19miyslmy0">
              <ul className="space-y-2" data-id="element-185" data-mp="1ri3zn2zy3g2q">
                {packageVolumes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-zinc-800" data-id="element-186" data-mp="k03c9rzbwy05">
                    <Check size={16} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-187" data-mp="fzb12t6wcj18" />
                    <span data-id="element-188" data-mp="hijh1n9cdt3e">{item}</span>
                  </li>)}
              </ul>
              <ul className="space-y-2 bg-zinc-100 border border-zinc-200 rounded-xl p-4" data-id="element-189" data-mp="mg31x60jp44b">
                {packageBonuses.map(item => <li key={item} className="flex items-start gap-2 text-sm text-zinc-800" data-id="element-190" data-mp="ci5gsrdzfnfx">
                    <Gift size={16} className="text-violet-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-191" data-mp="3uwxwzzb3pk7u" />
                    <span data-id="element-192" data-mp="3hqj0sju0fvj">{item}</span>
                  </li>)}
              </ul>
              <ul className="grid grid-cols-2 gap-2" data-id="element-193" data-mp="3kyqgtiomz66w">
                {packageExtras.map(item => <li key={item} className="flex items-start gap-2 text-sm text-zinc-800" data-id="element-194" data-mp="3pxbg9fw2dlua">
                    <Check size={16} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-195" data-mp="3by22snz8t5u0" />
                    <span data-id="element-196" data-mp="3fz5jtdt117wt">{item}</span>
                  </li>)}
              </ul>
            </div>

            <h3 className="text-2xl md:text-3xl font-black uppercase text-zinc-950 mb-3" data-id="element-197" data-mp="2xalblmeilf2m">
              Get the complete system today
            </h3>
            <div className="mb-6" data-id="element-198" data-mp="2se380pux7mrv">
              <span className="text-4xl md:text-5xl font-display font-black text-violet-600" data-id="element-199" data-mp="36bjc3upqv4gg">$27 USD</span>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-200" data-mp="31bn8vxovfh1y">
              Get MMA Coach Ready Now
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-zinc-500 mb-4" data-id="element-201" data-mp="3b91pbxaso5u9">
              <span className="flex items-center gap-1.5" data-id="element-202" data-mp="3p43wenrdo18n">
                <Lock size={12} className="text-green-600" aria-hidden="true" data-id="element-203" data-mp="3l17hb711qn9g" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-204" data-mp="2vcaruusxjau">
                <Zap size={12} className="text-green-600" aria-hidden="true" data-id="element-205" data-mp="3u25d521bzogy" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-206" data-mp="hxb3gppf5zrx">
                <Check size={12} className="text-green-600" aria-hidden="true" data-id="element-207" data-mp="lzfv5iwb4mbx" /> Complete Digital
                Bundle
              </span>
            </div>

            <div className="bg-zinc-100 border border-zinc-200 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-208" data-mp="qr669r32je4e">
              <Globe className="text-zinc-950 shrink-0 mt-0.5" size={14} aria-hidden="true" data-id="element-209" data-mp="3v4mb70vz1xgr" />
              <p className="text-[11px] text-zinc-500 leading-snug" data-id="element-210" data-mp="30tsw0p20p6f">
                Payment availability and currency conversion may vary according to your checkout
                provider and country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}